<template>
  <div class="transactionList">
    <div class="transactionList__list__item">
        <div class="transactionList__list__item__left">
          <div class="transactionList__list__item__left__info">
            <p class="small-font title">Campaign Name</p>
            <h3 class="subhead name">{{campaign.name}}</h3>
            <p class="small-font invoice">ID {{campaign.number}}</p>
          </div>
        </div>
        <div class="transactionList__list__item__middle">
          <div class="transactionList__list__item__middle__status">
            <p class="small-font title">
              Campaign Type :
            </p>
            <div class="content">
              {{campaign.type_display}}
            </div>
          </div>
        </div>
        <div class="transactionList__list__item__middle">
          <div class="transactionList__list__item__middle__status">
            <p class="small-font title">
              Campaign Status :
            </p>
            <div class="content">
              <ul>
                <template v-if="campaign.state_display == 'Waiting for Payment'">
                  <li class="small-font active">Pending Payment</li>
                  <li class="small-font">Waiting for Approval</li>
                  <li class="small-font">Active</li>
                  <li class="small-font">Campaign End</li>
                </template>
                <template v-if="campaign.state_display == 'Waiting for Approval'">
                  <li class="small-font active">Pending Payment</li>
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font">Active</li>
                  <li class="small-font">Campaign End</li>
                </template>
                <template v-if="campaign.state_display == 'Active'">
                  <li class="small-font active">Pending Payment</li>
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font active">Active</li>
                  <li class="small-font ">Campaign End</li>
                </template>
                <template v-if="campaign.state_display == 'End'">
                  <li class="small-font active">Pending Payment</li>
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font active">Active</li>
                  <li class="small-font active">Campaign End</li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="transactionList__list__item__right">
          <div class="transactionList__list__item__right__price">
            <p class="small-font title">Total price</p>
            <h3 class="subhead price">{{campaign.get_price | formatMoney}}</h3>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-transaction-list',
  components: {
  },
  props: {
    campaign: {
      required: false
    },
    orderStatus: {
      required: false
    },
  },
  data() {
    return {
      isOpen: window.innerWidth < 769 ? true : false
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 769 ? false : true
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    gotoInvoice(itemID) {
      this.$router.push({name:'invoicereceipt', params: { invoice_id: itemID }})
    },
    formatDate(date) {
      return formatShortDate(date)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>